<template>
  <div class="dialog-interest-form">
    <v-overlay v-if="isLoading" color="white" absolute opacity="0.5">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <v-form @submit.prevent="onSubmit" ref="interestForm" v-if="!isLoading" :disabled="isDisable">
      <v-card-text class="overflow-y-auto dialog-interest-form-in">
        <!-- Content Space -->
        <div class="flex items-center justify-between mb-5" v-if="isUpdate">
          <div></div>
          <div class="text-base text-right">
            <label for class="block mb-2">{{ $t('market.status_of_operation') }}</label>
            <v-chip class="chip-status" :class="form.statusColor">
              <v-icon left x-small> mdi-circle </v-icon>
              {{ form.getStatusString }}
            </v-chip>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-4">
          <div :class="`
                flex
                justify-center
                rounded-md
                border-2
                ${!form.isNewCustomer && 'active-select'}
                p-3
                shadow-md
                text-base
                font-bold
                cursor-pointer`" @click="!isDisable ? (form.isNewCustomer = false) : null">{{ $t('market.old_customer') }}</div>
          <div :class="`
                flex
                justify-center
                rounded-md
                border-2
                ${form.isNewCustomer && 'active-select'}
                p-3
                shadow-md
                text-base
                font-bold
                cursor-pointer`" @click="!isDisable ? (form.isNewCustomer = true) : null">{{ $t('market.new_customer') }}</div>
        </div>
        <div class="py-5" v-if="!form.isNewCustomer">
          <div class="flex justify-between">
            <h1 class="text-xl mb-2">
              <v-icon left>mdi-account</v-icon>{{ $t('customer.select_customer') }}
            </h1>
            <v-btn color="success" text @click="searchDialog = true" :disabled="isView || isDisable">
              <v-icon left>mdi-magnify</v-icon>{{ $t('customer.search_customer') }}
            </v-btn>
          </div>
          <template v-if="currentCustomer">
            <customer-card 
              :emails="currentCustomer.emails" 
              :firstName="currentCustomer.firstName"
              :lastName="currentCustomer.lastName"
              :tels="currentCustomer.tels"
              :interTels="currentCustomer.interTels"
              :companyName="currentCustomer.companyName"
              :type="currentCustomer.type"
              :img="currentCustomer.profileImages[0]
                ? currentCustomer.profileImages[0].url
                : '/user.png'
              "
              :url="`/project/${projectId}/market/${marketId}/customer/${currentCustomer.objectId}/view`"></customer-card>
          </template>
          <template v-if="!currentCustomer">
            <div class="text-center py-5">
              <span class="font-bold">{{ $t('customer.search_customer_data') }}..</span>
            </div>
          </template>
        </div>
        <div class="py-5" v-if="form.isNewCustomer">
          <CardReaderBox v-if="isWriteData" />
          <div class="mt-5">
            <h1 class="text-xl mb-2">{{ $t('customer.customer_type') }}</h1>
            <v-radio-group v-model="form.customerType">
              <div class="grid grid-cols-2 gap-4">
                <v-radio :label="$t('project.business_type_personal')" value="personal"></v-radio>
                <v-radio :label="$t('project.business_type_company')" value="company"></v-radio>
              </div>
            </v-radio-group>
          </div>
          <div class="flex justify-between">
            <h1 class="text-xl mb-2">
              <v-icon left>mdi-account</v-icon>{{ $t('customer.customer_information') }}
            </h1>
          </div>
          <div class="grid grid-cols-12 gap-4" v-if="form.customerType == 'personal'">
            <div class="col-span-2">
              <label for>{{ $t('account.prefix') }}</label>
              <v-combobox :placeholder="$t('account.prefix')" v-model="form.customerTitle" solo flat :items="[$t('account.mr'), $t('account.ms'), $t('account.mrs')]"
                background-color="grey lighten-4" hide-details></v-combobox>
            </div>
            <div class="col-span-5">
              <label for>{{ $t('account.first_name') }}</label>
              <v-text-field :placeholder="$t('account.first_name')" v-model="form.customerFirstName" solo :rules="[rules.firstName]" flat
                background-color="grey lighten-4"></v-text-field>
            </div>
            <div class="col-span-5">
              <label for>{{ $t('account.last_name') }}</label>
              <v-text-field :placeholder="$t('account.last_name')" v-model="form.customerLastName" solo flat
                background-color="grey lighten-4"></v-text-field>
            </div>
            <div class="col-span-6">
              <EditTaxId showLabel showWarning :getLabel="$t('account.citizen_id_label')" v-model='form.customerCitizenId'
                @input="form.customerCitizenId = $event" :getIsVat="false" :getRules="rules" :isCreate='isCreate' />
            </div>
            <div class="col-span-6">
              <PhoneNumber
                ref="phoneNumber"
                :tel.sync="form.customerTel"
                :interTel.sync="form.customerInterTel"
                solo
                flat
                background-color="grey lighten-4"
                :placeholder="$t('account.phone_number')"
              />
            </div>
            <div class="col-span-6">
              <label for>Email</label>
              <v-text-field placeholder="Email" v-model="form.customerEmail" solo flat :rules="[$helper.rules().email]"
                background-color="grey lighten-4"></v-text-field>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4" v-if="form.customerType == 'company'">
            <div>
              <label for>{{ $t('customer.company_name_title') }}</label>
              <v-text-field id="interest-form-company-name" :placeholder="$t('customer.company_name_title')" v-model="form.customerCompanyName"
                solo :rules="[rules.firstName]" flat background-color="grey lighten-4"></v-text-field>
            </div>
            <div>
              <label for>{{ $t('market.contact_person') }}</label>
              <v-text-field :placeholder="$t('market.contact_person')" v-model="form.customerCompanyContact" solo flat
                background-color="grey lighten-4"></v-text-field>
            </div>
            <div>
              <EditTaxId v-model='form.customerCitizenId' :getLabel="$t('tax.tax_id_number_another_form')" showWarning showLabel :isCreate='isCreate' getIsVat
                :getIsExport='!isDisable ? true : false' :getRules="rules" @input="form.customerCitizenId = $event"
                @onWriteData="onWriteData" />
            </div>
            <div>
              <PhoneNumber
                ref="phoneNumber"
                :tel.sync="form.customerTel"
                :interTel.sync="form.customerInterTel"
                solo
                flat
                background-color="grey lighten-4"
                :placeholder="$t('account.phone_number')"
              />
            </div>
            <div>
              <label for>Email</label>
              <v-text-field placeholder="Email" v-model="form.customerEmail" solo flat :rules="[$helper.rules().email]"
                background-color="grey lighten-4"></v-text-field>
            </div>
          </div>
        </div>
        <div>
          <h1 class="text-lg mb-2">{{ $t('area.interest_area_stall_detail') }}</h1>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <!-- // วันที่เริ่มสัญญา -->
              <label for>{{ $t('contract.start_date') }}</label>
              <v-menu ref="menuStartDate" v-model="menuStartDate" :close-on-content-click="false"
                :return-value.sync="form.contractStartDate" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field solo flat background-color="grey lighten-4"
                    :value="$helper.datelabel(form.contractStartDate)" :label="$t('contract.start_date')"
                    prepend-inner-icon="mdi-calendar" readonly hide-details v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="form.contractStartDate" no-title scrollable locale="th"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat" 
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" persistent-hint>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="menuStartDate = false">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="success" @click="$refs.menuStartDate.save(form.contractStartDate)">{{ $t('confirm') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div>
              <label for>{{ $t('contract.end_date') }}</label>
              <v-menu ref="menuEndDate" v-model="menuEndDate" :close-on-content-click="false"
                :return-value.sync="form.contractEndDate" transition="scale-transition" offset-y min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field solo flat background-color="grey lighten-4"
                    :value="$helper.datelabel(form.contractEndDate)" :label="$t('contract.start_date')"
                    prepend-inner-icon="mdi-calendar" readonly hide-details v-bind="attrs" v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="form.contractEndDate" no-title scrollable locale="th"
                  :header-date-format="$helper.headerDateFormat" :year-format="$helper.yearFormat" 
                  :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth" persistent-hint>
                  <v-spacer></v-spacer>
                  <v-btn text color="error" @click="menuEndDate = false">{{ $t('cancel') }}</v-btn>
                  <v-btn text color="success" @click="$refs.menuEndDate.save(form.contractEndDate)">{{ $t('confirm') }}</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div v-if="project">
              <label :for="project.layoutType == 1 ? 'zoneInput' : 'marketInput'">
                {{ project.layoutType == 1 ? $t('area.zone') : $t('market.market') }}
              </label>
              <v-select
                v-model="form.marketId"
                solo 
                background-color="grey lighten-4"
                flat
                hide-details
                :items="marketOptions" 
                item-text="name"
                item-value="objectId"
                :label="project.layoutType == 1 ? $t('area.select_zone') : $t('market.select_market')"
                :input-id="project.layoutType == 1 ? 'zoneInput' : 'marketInput'"
                @change="onMarketChange"
                :no-data-text="$t('noinfo')"
              />
            </div>
            <div>
              <label for>{{ $t('area.stall_type') }}</label>
              <v-select solo background-color="grey lighten-4" flat hide-details :items="[
                { text: $t('contact.stall_type.regularly'), value: 'regularly' },
                { text: $t('contact.stall_type.temporary'), value: 'temporary' },
              ]" v-model="form.stallType" :label="$t('area.select_stall_type')" :no-data-text="$t('noinfo')"></v-select>
            </div>
            <div>
              <label for>{{ $t('area.interested_stall') }}</label>
              <p class="text-lg">
                {{ form.areaIds.length }}
                <span class="text-sm">{{ $t('area.space') }}</span>
              </p>
              <v-btn small elevation="0" @click="addAreasToForm" :disabled="isDisable || isLoadingArea">
                <v-icon left>mdi-plus</v-icon>{{ $t('area.add_stall') }}
              </v-btn>
            </div>
            <div class="grid grid-cols-2 gap-4 col-span-2">
              <div class="col-span-2">
                <div class="rounded py-1 text-yellow-400">
                  <v-icon left>mdi-information</v-icon>{{ $t('area.empty_stall_if_not_specify') }}
                </div>
              </div>
              <!-- {{ getAreas }} -->
              <div v-for="(a, a_index) in form.areaIds" :key="'a_index' + a_index" v-if="!isLoadingArea">
                <span>{{ $t('area.stall_at') }} {{ a_index + 1 }}</span>
                <v-autocomplete :placeholder="$t('area.not_specify_stall')" solo flat :items="areaOptions" hide-details item-value="objectId"
                  :item-text="(r) =>
                    `${r.name} - ${r.status != 0 || r.areaInterest ? $t('not_empty') : $t('empty')
                    } ${r.areaInterest
                      ? r.areaInterest.objectId == form.objectId
                        ? `(${$t('area.stall_reserved')})`
                        : `(${$t('area.reserved')})`
                      : ''
                    }`
                    " background-color="grey lighten-4" v-model="form.areaIds[a_index]" append-outer-icon="mdi-close"
                  @click:append-outer="removeArea(a_index)">
                  <template slot="item" slot-scope="data">
                    {{ data.item.name }}
                    <span v-if="data.item.status != 0 || data.item.areaInterest" class="text-red-500 mx-3">{{ $t('not_empty') }}</span>
                    <span v-else class="text-screamin-green-500 mx-3">{{ $t('empty') }}</span>
                    <template v-if="data.item.areaInterest">
                      <span class="text-yellow-500">
                        {{
                          data.item.areaInterest.objectId === form.objectId
                          ? `(${$t('area.stall_reserved')})`
                          : `(${$t('area.reserved')})`
                        }}
                      </span>
                    </template>
                  </template>
                </v-autocomplete>
              </div>
            </div>
            <div class="col-span-2">
              <span>{{ $t('product.product_in_sell') }}</span>
              <v-autocomplete solo flat background-color="grey lighten-4" v-model="form.productIds" :items="products"
                item-text="name" item-value="objectId" multiple hide-details>
                <template v-slot:append-outer>
                  <v-icon v-if="admin || (employee && employee.enableAddProduct)"
                    @click="isProduct = true">mdi-plus</v-icon>
                  <v-tooltip v-else top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        <v-icon disabled>mdi-plus</v-icon>
                      </div>
                    </template>
                    <span>{{ $t('product.no_permission_to_add_product') }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </div>
            <div class="col-span-2">
              <span>{{ $t('project.image_or_file_if_have') }}</span>
              <ImageUpload v-model="imageFiles" :isLoading="isUploading" :isView="isView || isDisable"
                refName="fileupload" />
            </div>

            <div class="col-span-2">
              <span>{{ $t('note') }}</span>
              <v-text-field solo flat background-color="grey lighten-4" v-model="form.note" hide-details></v-text-field>
            </div>

            <div class="col-span-2" v-if="form.objectId">
              <span>{{ $t('document') }}</span>
              <div class="border-box mt-2">
                <v-tabs v-model="documentTab">
                  <v-tab value="quotation">{{ $t('bill.quotation') }}
                    <v-badge v-if="form.quotations && form.quotations.length" color="error">
                      <template v-slot:badge>
                        <span>{{ form.quotations.length }}</span>
                      </template>
                    </v-badge>
                  </v-tab>
                  <v-tab value="document">{{ $t('customer.document_set') }}
                    <v-badge v-if="getContractDocuments && getContractDocuments.length" color="error">
                      <template v-slot:badge>
                        <span>{{ getContractDocuments.length }}</span>
                      </template>
                    </v-badge>
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="documentTab" class="pt-5 px-4">
                  <v-tab-item key="quotation">
                    <div class="flex justify-between">
                      <h4>{{ $t('bill.quotation') }}</h4>
                      <v-btn v-if="!form.quotations" color="info" small elevation="0" @click="createQuotation()"
                        :disabled="isLoading || form.status != 'pending'">
                        <v-icon left>mdi-plus-box</v-icon>{{ $t('bill.export_quotation') }}
                      </v-btn>
                    </div>
                    <template v-if="form && form.quotations">
                      <div v-for="quotation in form.quotations"
                        class="px-3 py-2 rounded shadow bg-white flex justify-between items-center mb-2"
                        :key="quotation.objectId">
                        <div>
                          <div>
                            {{ $t('bill.quotation') }}
                            <span class="font-bold text-picton-blue-600"> {{ quotation.totalValue | currencySuffixTextThEn(quotation.currencyCode) }} </span>
                          </div>
                          <div class="note" v-if="quotation.updatedBy">{{ $t('product.last_updated_by') }} {{ quotation.updatedByText }}</div>
                          <div class="note" v-if="quotation.updatedAt">{{ $t('product.last_updated_at') }} {{ quotation.updatedAtText }}
                          </div>
                        </div>
                        <div>
                          <v-btn color="info" small text @click="showQuotations(quotation)">{{ $t('detail') }}</v-btn>
                        </div>
                      </div>
                    </template>
                    <div v-else
                      class="px-3 py-3 my-3 text-gray-400 py-2 rounded shadow bg-white flex justify-between items-center">
                      <div>{{ $t('bill.no_have_quotation') }}</div>
                    </div>
                  </v-tab-item>
                  <v-tab-item key="document">
                    <div class="flex justify-between">
                      <h4>{{ $t('customer.document_set_list') }}</h4>
                      <v-btn color="info" small elevation="0" @click="contractDocumentDialog($event, false)"
                        :disabled="isLoadingContractDocument || isLoading || form.status != 'pending'">
                        <v-icon left>mdi-plus-box</v-icon>{{ $t('contract.add_contract_document') }}
                      </v-btn>
                    </div>
                    <div class="py-1">
                      <CardContractDocument v-for="( doc, index ) of getContractDocuments" :key="`doc_${index}`"
                        :indexNumber="`${index + 1}`" :object="doc" @onView="contractDocumentDialog(doc, true, true)"
                        @onUpdated="contractDocumentDialog(doc, true)" @onRemove="contractDocumentRemoveDialog(doc)"
                        :isDisabled="isLoadingContractDocument || isLoading || form.status != 'pending'"
                        :isShowDateEdit="true" />

                      <CardContractDocument v-if="getContractDocuments.length < 1" :isNull="true" />
                    </div>
                  </v-tab-item>
                </v-tabs-items>
              </div>
            </div>
          </div>

        </div>
      </v-card-text>
      <template v-if="!isView">
        <v-divider></v-divider>
        <v-card-actions class="mx-2 bottom-0 right-0">
          <v-btn v-if="isUpdate && form.status == 'pending'" color="warning" @click="onEditMode" elevation="0">
            <v-icon left>mdi-pencil</v-icon>{{ $t('account.edit_data') }}
          </v-btn>
          <v-btn v-if="form.status == 'approving'" color="warning" elevation="0" type="button" :loading="isLoading"
            @click="cancleApproving">{{ $t('customer.cancel_approval') }}</v-btn>
          <v-spacer></v-spacer>
          <template v-if="(!isDisable && form.status == 'pending') || isCreate">
            <v-btn color="error" elevation="0" @click="onCancel">
              <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
            </v-btn>
            <v-btn color="success" elevation="0" type="submit" :loading="isLoading"
              :disabled="(checkLocale == 'th' && !clickRule()) || isDisable || isLoading" v-if="!isDisable">
              <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
            </v-btn>
          </template>
          <template v-else>
            <v-btn v-if="isUpdate && (form.status == 'pending' || form.status == 'waiting_contract')" color="error"
              elevation="0" type="button" :loading="isLoading" @click="preCancelled">
              <v-icon left>mdi-close</v-icon>{{ $t('cancel') }}
            </v-btn>
            <v-btn v-if="form.status == 'pending'" color="info" elevation="0" type="button" :loading="isLoading"
              @click="preApproving">{{ $t('market.send_approval') }}</v-btn>
            <template
              v-if="form.status == 'approving' && (admin || (employee && employee.enableViewApprove && employee.enableApproveAreaInterest))">
              <v-btn color="error" elevation="0" type="button" :loading="isLoading" @click="isConfirmReject = true">
                <v-icon left>mdi-close</v-icon>{{ $t('task.not_approve') }}
              </v-btn>
              <v-btn color="success" elevation="0" type="button" :loading="isLoading" @click="isConfirmApprove = true">
                <v-icon left>mdi-check</v-icon>{{ $t('task.approve') }}
              </v-btn>
            </template>
            <template v-if="form.status == 'checking'">
              <v-btn color="error" elevation="0" type="button" :loading="isLoading" @click="preCancelled">
                <v-icon left>mdi-close</v-icon>{{ $t('reject') }}
              </v-btn>
              <v-btn color="info" elevation="0" type="button" :loading="isLoading" @click="preWaiting">
                <v-icon left>mdi-check</v-icon>{{ $t('accept') }}
              </v-btn>
            </template>
            <v-btn color="info" elevation="0" type="button" :loading="isLoading" v-if="form.status == 'waiting_contract'"
              @click="onSelectDepositItemDialog()"
              :disabled="!form.quotations || (form.quotations && !form.quotations.length)">
              <v-icon left>mdi-content-duplicate</v-icon>{{ $t('bill.create_deposit_bill_or_enter_stall') }}
            </v-btn>
            <v-btn color="success" elevation="0" type="button" :loading="isLoading"
              v-if="form.status == 'waiting_contract'" @click="successInterest">
              <v-icon left>mdi-check</v-icon>{{ $t('area.enter_stall') }}
            </v-btn>
          </template>
        </v-card-actions>
      </template>
    </v-form>
    <customer-search-dialog v-model="searchDialog" @select="selectCustomer"></customer-search-dialog>
    <v-snackbar v-model="isError" color="error" top centered>
      {{
        errorMsg
      }}
    </v-snackbar>
    <quotation-dialog v-model="isQuotation" :projectId="projectId" :marketId="marketId" :areaInterestId="form.objectId"
      @onSaveSuccess="getAreaInterest" :quotationId="quotationId" :type="`area-interest`"></quotation-dialog>
    <confirm-dialog v-model="isConfirm" :title="`${$t('appeal.send_appeal')}`"
      :description="`${$t('validate.if_you_send_approval_you_can_not_edit_data_again')}`"
      @onOk="updateAreaInterestStatus('approving'); isConfirm = false;" :confirmColor="`success`">
      <template v-if="!form.quotations" v-slot:content>
        <div class="text-orange-500 py-2">
          - {{ $t('customer.not_export') }} <b>{{ $t('bill.quotation') }}</b>
        </div>
      </template>
    </confirm-dialog>
    <confirm-dialog v-model="isConfirmCancleApprove" :title="`${$t('customer.cancel_send_approval')}`"
      :description="`${$t('validate.if_you_cancel_send_approval_the_list_that_has_been_sent_will_be_canceled')}`"
      @onOk="updateAreaInterestStatus('pending'); isConfirmCancleApprove = false;" :confirmColor="`warning`">
      <template v-if="!form.quotations" v-slot:content>
        <div class="text-orange-500 py-2">
          - {{ $t('customer.not_export') }} <b>{{ $t('bill.quotation') }}</b>
        </div>
      </template>
    </confirm-dialog>
    <confirm-dialog :title="`${$t('booking.cancel_or_reject_booking')}`"
      :description="`${$t('booking.you_cannot_change_data_after_cancel_or_reject_booking')}`" @onOk="
        updateAreaInterestStatus('cancelled');
      isConfirmCancelled = false;
      " :confirmColor="`error`" v-model="isConfirmCancelled"></confirm-dialog>
    <confirm-dialog :title="`${$t('customer.accept_quotation')}`" :description="`${$t('customer.accept_quotation_from_customer')}`" @onOk="
      updateAreaInterestStatus('waiting_contract');
    isConfirmWaiting = false;
    " :confirmColor="`success`" v-model="isConfirmWaiting"></confirm-dialog>
    <form-product v-model="isProduct" @onLoad="loadInit" :event="`create`"></form-product>
    <v-dialog v-model="isDuplicateCustomer" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="warning text-white">
          <h4>{{ $t('validate.have_customer_in_system_do_you_want_to_add_customer_again') }}</h4>
        </v-card-title>
        <v-card-text>
          <template v-if="duplicateCustomers">
            <v-card v-for="customer in duplicateCustomers" :key="customer.objectId" class="mt-4">
              <v-card-text class="pt-2">
                <h4>{{ customer.fullNameNoTitle }}</h4>
                <div><b>{{ $t('number_another_format') }} : </b> {{ customer.fullTels || "-" }}</div>
                <div>
                  <b v-if="customer.type == 'company'">{{ $t('tax.tax_id_number_another_form') }} : </b>
                  <b v-else>{{ $t('account.citizen_id_label') }} : </b>
                  {{ customer.citizenId || "-" }}
                </div>
              </v-card-text>
            </v-card>
          </template>
        </v-card-text>
        <v-card-actions class="border-t">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="isDuplicateCustomer = false" :disabled="isLoading">{{ $t('close') }}</v-btn>
          <v-btn color="success" type="submit" elevation="0" :disabled="isLoading"
            @click="isCreate ? createAreaInterest() : updateAreaInterest()">{{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isSelectDepositItem" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="warning text-white">
          <h4>{{ $t('payment.select_deposit') }} <small>({{ $t('payment.from_quotation') }})</small></h4>
        </v-card-title>
        <v-card-text class="px-1">
          <v-data-table
            v-model="depositItems"
            :headers="depositDataTable.headers"
            :items="depositDataTable.data"
            hide-default-footer show-select
            :single-select="false"
            :no-data-text="$t('noinfo')"
            :no-results-text="$t('no_matching_records_found')">
            <template v-slot:item.vat="{ item }">
              <template v-if="item.sellVatType == 1">V</template>
            </template>
            <template v-slot:item.totalValue="{ item }">
              {{ item.totalValue | currency }}
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="border-t">
          <v-spacer></v-spacer>
          <v-btn color="error" elevation="0" @click="isSelectDepositItem = false" :disabled="isLoading">{{ $t('close') }}</v-btn>
          <v-btn color="success" elevation="0" type="button" :loading="isLoading" v-if="form.status == 'waiting_contract'"
            @click="successInterest">
            <v-icon left>mdi-check</v-icon>{{ $t('area.enter_stall') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog :loading="isLoading" :disabled="isLoading" :title="$t('task.approve_quotation')"
      :description="$t('task.want_to_approve_quotation')" @onOk="approveInterest()" :confirmColor="`success`"
      v-model="isConfirmApprove"></confirm-dialog>
    <confirm-dialog :loading="isLoading" :disabled="isLoading" :title="$t('validate.not_approve_this_quotation')"
      :description="$t('task.want_to_approve_quotation')" @onOk="rejectInterest()" :confirmColor="`error`"
      v-model="isConfirmReject"></confirm-dialog>
    <form-contract v-model="isContractDialog" @onUpdated="onCheckinSuccess" :obj="contract ? contract : null"
      event="edit"></form-contract>
    <form-customer v-model="isCustomerDialog" :objectId="customer ? customer.id : null" :close="false"
      @onUpdated="isContractDialog = true" event="edit"></form-customer>
    <contract-document v-model="isContractDocument" :projectId="projectId" :marketId="marketId" :contract-id="null"
      :isUpdate="isContractDocumentUpdate" :object-id="isContractDocumentId" :isDisable="isContractDocumentDisable"
      :areaInterestId="form.objectId"></contract-document>
    <confirm-dialog-component v-model="isConfirmContractDocumentRemove" @onOk="contractDocumentRemove"
      :title="$t('validate.you_want_to_delete_this_document_set')" type="error"></confirm-dialog-component>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CustomerCard from "./CustomerCard.vue";
import CustomerSearchDialog from "./CustomerSearchDialog.vue";
import QuotationDialog from "./QuotationDialog.component.vue";
import ConfirmDialog from "./ConfirmDialog.vue";
import FormProduct from "./FormProduct.vue";
import CardReaderBox from "./CardReaderBox.vue";
import { Customer, Contract, Market } from "../classes";
import FormCustomer from "../components/FormCustomer.vue";
import FormContract from "../components/FormContract.vue";
import ImageUpload from "./ImageUpload.vue";
import CardContractDocument from "./CardContractDocument.vue";
import ContractDocument from "./ContractDocument.vue";
import ConfirmDialogComponent from "./ConfirmDialog.component.vue";
import EditTaxId from "@/components/EditTaxId.vue";
import PhoneNumber from "@/components/PhoneNumber.vue";

export default {
  components: {
    CustomerSearchDialog,
    CustomerCard,
    QuotationDialog,
    ConfirmDialog,
    FormProduct,
    CardReaderBox,
    FormCustomer,
    FormContract,
    ImageUpload,
    CardContractDocument,
    ContractDocument,
    ConfirmDialogComponent,
    EditTaxId,
    PhoneNumber
  },
  name: "InterestFormVue",
  computed: {
    admin() {
      return this.getAdminByMarketId(this.marketId);
    },
    employee() {
      return this.getEmployeeByMarketId(this.marketId);
    },
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    },
    projectLocale() {
      if (this.admins && this.admins.length) {
        return this.admins[0].project;
      } else if (this.employees && this.employees.length) {
        return this.employees[0].project;
      } else if (this.admin) {
        return this.admin.project;
      } else if (this.employee) {
        return this.employee.project;
      }
      return { locale: "th" };
    },
    checkLocale() {
      return this.projectLocale?.locale || "th";
    },    
    ...mapGetters({
      getAdminByMarketId: "admin/getByMarketId",
      getEmployeeByMarketId: "employee/getByMarketId",
      getAreas: "markets/getAreas",
      areaInterest: "areaInterest/getAreaInterest",
      products: "product/getProducts",
      getReadData: "socket/getReadData",
      getContractDocuments: "contractDocument/getContractDocuments"
    }),
    areaItems() {
      return this.getAreas.sort(function (a, b) {
        if (b.order > a.order) return -1;
        else return 1;
      });
    },
    interestFormVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    isLoading: {
      get() {
        return this.loading;
      },
      set(value) {
        this.loading = value;
        this.$emit("onLoading", value);
      }
    },
    isWriteData() {
      let isWriteData = false;
      isWriteData =
        this.form.isNewCustomer && this.form.customerType == "personal" && (this.isCreate || this.isUpdate) && !this.isView && !this.isDisable
          ? true
          : false;
      return isWriteData;
    }
  },
  watch: {
    value(data) {
      if (data) {
        // this.resetForm();
        this.initData();
      }
    },
    getReadData: {
      handler(data) {
        if (this.isWriteData && data && data.success) {
          this.setData(data.data);
        }
      },
      deep: true,
      immediate: true
    },
    imageFiles: {
      handler(imageFiles) {
        if (imageFiles && imageFiles.length) this.form.imageFiles = imageFiles
        else this.form.imageFiles = []
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    if (this.admins && this.admins.length) {
      this.project = this.admins[0].project;
      for (let admin of this.admins) {
        this.marketOptions.push(admin.market);
      }
    }
    if (this.employees && this.employees.length) {
      this.project = this.employees[0].project;
      for (let employee of this.employees) {
        if (employee.enableViewAreaInterests) {
          this.marketOptions.push(employee.market);
        }
      }
    }
    this.initData();
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      project: null,
      market: null,
      rules: {
        firstName: v => !!v || this.$t('validate.please_input_customer_name'),
        lastName: v => !!v || this.$t('validate.please_input_customer_last_name'),
        tel: v => !!v || this.$t('validate.please_input_customer_phone'),
        max10: v => v.length == 0 || v.length == 10 || this.$t('validate.please_input_customer_phone_not_more_than_ten_characters'),
        texId: v => v?.length == 0 || v?.length == 13 || this.$t('validate.please_input_data_correct_thirteen_digit'),
        numbersOnly: v => !v || /^\d+$/.test(v) || this.$t('validate.numbers_only'),
      },
      clickRule: () =>
        (!this.form.isNewCustomer || !this.form.customerCitizenId || this.form.customerCitizenId.length == 13)
      ,
      quotationId: null,
      isQuotation: false,
      isConfirm: false,
      isProduct: false,
      form: {
        contractStartDate: this.$moment().format("YYYY-MM-DD"),
        contractEndDate: this.$moment()
          .add(1, "month")
          .format("YYYY-MM-DD"),
        stallType: "regularly",
        customerTitle: "",
        customerFirstName: "",
        customerLastName: "",
        customerCompanyContact: "",
        customerCompanyName: "",
        customerTel: "",
        customerInterTel: "",
        customerCitizenId: "",
        customerType: "personal",
        isNewCustomer: false,
        areasQty: 1,
        areaIds: [],
        imageFiles: [],
        sellProduct: "",
        note: "",
        productIds: [],
        customerEmail: ""
      },
      text: {
        title: this.$t('market.interested_in_business'),
        isCreate: this.$t('action_type.add'),
        isUpdate: this.$t('action_type.edit')
      },
      menuStartDate: false,
      menuEndDate: false,
      select: 1,
      searchDialog: false,
      currentCustomer: null,
      isError: false,
      errorMsg: "",
      loading: false,
      isDisable: false,
      isUploading: false,
      statusResponse: null,
      isConfirmCancelled: false,
      isConfirmWaiting: false,
      isConfirmApprove: false,
      isConfirmReject: false,
      isConfirmCancleApprove: false,
      duplicateCustomers: null,
      isDuplicateCustomer: false,
      isSelectDepositItem: false,
      depositItems: [],
      depositDataTable: {
        headers: [
          {
            text: this.$t('list'),
            align: "left",
            value: "name"
          },
          {
            text: this.$t('tax.title'),
            align: "center",
            value: "vat"
          },
          {
            text: this.$t('price'),
            align: "right",
            value: "totalValue"
          },
        ],
        data: []
      },
      isCustomerDialog: false,
      isContractDialog: false,
      customer: null,
      contract: null,
      imageFiles: [],
      isContractDocument: false,
      isContractDocumentUpdate: false,
      isContractDocumentId: "",
      isContractDocumentDisable: false,
      isConfirmContractDocumentRemove: false,
      isLoadContractDocument: false,
      isLoadingContractDocument: false,
      documentTab: 1,
      marketOptions: [],
      areaOptions: [],
      isLoadingArea: false,
    };
  },
  props: {
    value: Boolean,
    objectId: String,
    isUpdate: Boolean,
    isCreate: Boolean,
    isView: Boolean,
    approveId: String,
    areaIds: Array,
  },
  methods: {
    checkAreaMatch(areaInterestId) {
      const res = this.getAreas.find(
        area => area?.areaInterest.objectId === areaInterestId
      );
      return res;
    },
    checkMatch(areaId) {
      return this.form.areaIds.includes(areaId);
    },
    preCancelled() {
      this.isConfirmCancelled = true;
    },
    preWaiting() {
      this.isConfirmWaiting = true;
    },
    async successInterest() {
      try {
        const success = await this.updateAreaInterestStatus("success");
        this.checkinData(this.statusResponse)
      } catch (e) {
        this.$toast.show({
          content: this.$t('validate.error_stall_is_not_empty'),
          color: "error"
        });
      }
    },
    onEditMode() {
      this.$toast.show({
        content: this.$t('customer.edit_data_mode'),
        color: "warning"
      });
      this.isDisable = false;
    },
    showQuotations(object) {
      this.quotationId = object.objectId;
      this.isQuotation = true;
    },
    createQuotation() {
      // this.documentTab = 1;
      this.quotationId = null;
      this.isQuotation = true;
    },
    preApproving() {
      this.isConfirm = true;
    },
    cancleApproving() {
      this.isConfirmCancleApprove = true;
    },
    onSubmit() {
      try {
        if (this.$refs.interestForm.validate() && (!this.$refs.phoneNumber || (this.$refs.phoneNumber && this.$refs.phoneNumber.validate()))) {
          if (this.form.areaIds.length >= 1) {
            if (this.form.isNewCustomer) {
              if (this.form.customerType == "personal") {
                if (
                  this.form.customerTitle ||
                  this.form.customerFirstName ||
                  this.form.customerLastName ||
                  this.form.customerTel
                ) {
                  this.isError = false;
                  this.errorMsg = "";
                  this.onSubmitForm();
                } else {
                  this.isError = true;
                  this.errorMsg = this.$t('validate.please_input_customer_data');
                }
              } else {
                if (
                  this.form.customerCompanyName ||
                  this.form.customerCompanyContact ||
                  this.form.customerTel
                ) {
                  this.isError = false;
                  this.errorMsg = "";
                  this.onSubmitForm();
                }
              }
            } else {
              if (this.currentCustomer) {
                this.isError = false;
                this.errorMsg = "";
                this.onSubmitForm();
              } else {
                this.isError = true;
                this.errorMsg = this.$t('validate.please_input_customer_data');
              }
            }
          } else {
            this.isError = true;
            this.errorMsg = this.$t('validate.please_input_at_least_one_stall');
          }
        }
      } catch (e) {
        this.isError = true;
        this.errorMsg = e.message;
      }
    },
    async onSubmitForm() {
      this.isLoading = true;
      try {
        this.duplicateCustomers = await Customer.getDuplicateCustomers({
          projectId: this.projectId,
          tels: [this.form.customerTel],
          citizenId: this.form.customerCitizenId
        })
        if (this.duplicateCustomers && this.duplicateCustomers.length) {
          this.isDuplicateCustomer = true
          this.isLoading = false
        } else {
          if (this.isCreate) {
            this.createAreaInterest()
          } else {
            this.updateAreaInterest();
          }
        }
      } catch (err) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    addAreasToForm() {
      this.form.areaIds.push("");
    },
    removeArea(index) {
      this.form.areaIds.splice(index, 1);
    },
    onNumberOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onAreaQtyChange() {
      // check if areaQty is less than areas.length
      if (this.form.areasQty < this.form.areas.length) {
        this.form.areas = this.form.areas.slice(0, this.form.areasQty);
      }
    },
    selectCustomer(value) {
      this.currentCustomer = value;
    },

    async initData() {
      try {
        if (this.isUpdate) {
          this.isDisable = true;
          this.getAreaInterest(this.objectId);
          this.getProducts();
        } else {
          this.getProducts();
          this.resetForm();
          if (this.areaIds?.length) {
            this.form.areaIds = this.areaIds
          }
        }
        this.areaOptions = this.getAreas.sort(function (a, b) {
          if (b.order > a.order) return -1;
          else return 1;
        });
        this.$emit("onInit");
      } catch (e) {
        console.log(e);
      }
    },
    async saveData() {
      try {
        const params = this.form;
      } catch (e) {
        console.log(e);
      }
    },
    async createAreaInterest() {
      try {
        const params = this.form;
        if (!this.form.isNewCustomer)
          Object.assign(params, { customerId: this.currentCustomer.objectId });
        this.isLoading = true;
        const response = await this.$store.dispatch(
          "areaInterest/createAreaInterest",
          {
            ...params,
            areasQty: this.form.areaIds.length,
            marketId: this.form.marketId,
            contractStartDate: this.$moment(params.contractStartDate)
              .startOf("day")
              .toDate(),
            contractEndDate: this.$moment(params.contractEndDate)
              .endOf("day")
              .toDate()
          }
        );
        if (response) {
          // this.interestFormVueDialog = false;
          this.$nextTick(() => {
            this.resetForm();
            this.$emit("onCreate", response);
          });
          // this.interestFormVueDialog = false;
        }
        this.$eventBus.$emit("updateAreaPlan");
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.$toast.show({
          content: e.message,
          color: "error"
        });
        this.errorMsg = e.message;
      }
    },
    async getProducts() {
      try {
        const response = await this.$store.dispatch("product/getProducts", {
          projectId: this.$route.params.projectId
        });
      } catch (e) {
        console.log(e);
      }
    },
    async updateAreaInterest() {
      try {
        const params = this.form;
        if (!this.form.isNewCustomer) {
          Object.assign(params, { customerId: this.currentCustomer.objectId });
        }
        this.isLoading = true;
        const response = await this.$store.dispatch(
          "areaInterest/updateAreaInterest",
          {
            ...params,
            id: params.objectId,
            areasQty: this.form.areaIds.length,
            marketId: this.form.marketId,
            contractStartDate: this.$moment(params.contractStartDate)
              .startOf("day")
              .toDate(),
            contractEndDate: this.$moment(params.contractEndDate)
              .endOf("day")
              .toDate()
          }
        );
        if (response) {
          // this.interestFormVueDialog = false;
          this.$nextTick(() => {
            this.$toast.show({
              content: this.$t('save_success'),
              color: "success"
            });
            this.isDisable = true;
            this.getAreaInterest();
            this.$emit("onUpdate", response);
          });
        }
        this.$eventBus.$emit("updateAreaPlan");
        this.isDuplicateCustomer = false
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        this.isError = true;
        this.errorMsg = e.message;
      }
    },
    onSave() {
      try {
        const response = this.saveData();
        this.interestFormVueDialog = false;
        this.$emit("onSave", response);
      } catch (e) {
        console.log(e);
      }
    },
    onCancel() {
      try {
        this.interestFormVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },

    async getAreaInterest() {
      try {
        this.isLoading = true;
        const response = await this.$store.dispatch(
          "areaInterest/getAreaInterest",
          {
            id: this.objectId
          }
        );
        if (response) {
          await this.$store.dispatch("contractDocument/getContractDocuments", {
            areaInterestId: response.objectId
          });
          this.form = response;
          this.form.marketId = response.market.objectId
          this.form.contractStartDate = this.$moment(response.startDate).format("YYYY-MM-DD");
          this.form.contractEndDate = this.$moment(response.endDate).format("YYYY-MM-DD");
          this.form.areasQty = this.form.areas.length;
          this.currentCustomer = response.customer;
          this.imageFiles = response.imageFiles && response.imageFiles.length ? response.imageFiles : []
        }
        this.documentTab = 0;
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async updateAreaInterestStatus(status) {
      try {
        this.isLoading = true;
        let postData = {
          id: this.objectId,
          status: status
        }
        if (this.isSelectDepositItem) {
          postData.depositItems = this.depositItems
          postData.checkInItems = this.depositDataTable.data.filter(d => this.depositItems.indexOf(d) == -1)
        }
        const response = await this.$store.dispatch("areaInterest/updateAreaInterestStatus", postData);
        if (response) {
          this.$toast.show({
            content: this.$t('save_success'),
            color: "success"
          });
          this.getAreaInterest();
          this.$emit("onUpdate", response);
          this.statusResponse = response;
        }
        this.isLoading = false;
        this.isSelectDepositItem = false
      } catch (e) {
        this.$toast.show({
          content: e.error,
          color: "error"
        });
        // }
        this.isLoading = false;
      }
    },
    resetForm() {
      this.form = {
        contractStartDate: this.$moment().format("YYYY-MM-DD"),
        contractEndDate: this.$moment()
          .add(1, "month")
          .format("YYYY-MM-DD"),
        stallType: "regularly",
        customerFirstName: "",
        customerLastName: "",
        customerTel: "",
        customerCitizenId: "",
        customerType: "personal",
        isNewCustomer: false,
        areasQty: 1,
        areaIds: [],
        sellProduct: "",
        note: "",
        imageFiles: [],
        marketId: this.marketId,
        customerEmail: ""
      };
      this.imageFiles = []
      this.isDisable = false;
      this.currentCustomer = null;
      this.$store.commit("contractDocument/setContractDocuments", [])
    },
    async loadInit() {
      // await this.$store.dispatch("area/getVacancyAreas");
      // await this.$store.dispatch("product/getProducts", {
      //   projectId: this.$route.params.projectId
      //     ? this.$route.params.projectId
      //     : this.$store.getters["markets/getProjectId"]
      // });
    },
    setData(data) {
      let {
        fullNameTH,
        momentDateOfBirth,
        gender,
        momentIssueDate,
        momentExpireDate,
        cid,
        firstAddress,
        subDistrict,
        district,
        province,
        imageData
      } = data;
      this.form.customerTitle = fullNameTH.title || "";
      this.form.customerFirstName = fullNameTH.firstName || "";
      this.form.customerLastName = fullNameTH.lastName || "";
      // this.form.dateOfBirth = momentDateOfBirth.format("YYYY-MM-DD") || "";
      // this.form.gender = gender == "male" ? "m" : gender == "female" ? "f" : "";
      // this.form.citizenCardIssueDate =
      //   momentIssueDate.format("YYYY-MM-DD") || "";
      // this.form.citizenCardExpiryDate =
      //   momentExpireDate.format("YYYY-MM-DD") || "";
      this.form.customerCitizenId = cid || "";
      // this.form.addressStreet = firstAddress || "";
      // this.form.addressSubDistrict = subDistrict || "";
      // this.form.addressDistrict = district || "";
      // this.form.addressProvince = province || "";

      // let image = {
      //   name: "Picture from Thai ID card",
      //   url: "",
      //   isCardReader: true,
      //   imageData
      // };
      // this.form.profileImages_tmp = [image];
      // this.form.citizenCardImages_tmp = [image];
    },
    onSelectDepositItemDialog() {
      this.depositDataTable.data = []
      this.depositItems = []
      this.isSelectDepositItem = true
      if (this.form.quotations) {
        for (let quotation of this.form.quotations) {
          for (let [index, item] of quotation.items.entries()) {
            item.id = `${quotation.objectId}_${index}`
            this.depositDataTable.data.push(item)
          }
        }
      }
    },
    async approveInterest() {
      this.isLoading = true
      try {
        let response = await this.$store.dispatch("areaInterest/approveAreaInterest", {
          id: this.form.objectId
        })
        if (response) {
          this.$toast.show({
            content: this.$t('task.approve_success'),
            color: "success"
          });
        }
        this.getAreaInterest()
        this.$emit("onUpdate")
        this.isLoading = false
        this.isConfirmApprove = false
      } catch (err) {
        this.isLoading = false
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        })
      }
    },
    async rejectInterest() {
      this.isLoading = true
      try {
        let response = await this.$store.dispatch("areaInterest/rejectAreaInterest", {
          id: this.form.objectId
        })
        if (response) {
          this.$toast.show({
            content: this.$t('task.reject_approve_success'),
            color: "success"
          })
        }
        this.getAreaInterest()
        this.$emit("onUpdate")
        this.isLoading = false
        this.isConfirmReject = false
      } catch (err) {
        this.isLoading = false
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        })
      }
    },
    async checkinData(data) {
      if (data) {
        await Promise.all([
          this.getCustomer(data.customer.objectId),
          this.getContract(data.contract.objectId)
        ])
        this.isCustomerDialog = true;
      }
    },
    async getCustomer(customerId) {
      try {
        this.customer = await Customer.getCustomer({
          id: customerId
        });
      } catch (e) {
        this.$toast.show({
          content: this.$t('validate.error_call_customer_data'),
          color: "error"
        });
      }
    },
    async getContract(contractId) {
      try {
        this.contract = await Contract.getContract({
          id: contractId
        })
      } catch (e) {
        this.$toast.show({
          content: this.$t('contract.error_get_contract'),
          color: "error"
        });
      }
    },
    onCheckinSuccess() {
      this.$emit("onSuccess", this.statusResponse);
      this.interestFormVueDialog = false;
    },
    onWriteData(dataTax) {
      if (this.form.customerType == 'company' && dataTax) {
        this.form.customerCompanyName = dataTax.companyName
        this.$forceUpdate();
        // this.form.addressStreet = dataTax.addressStreet;
        // this.form.addressSubDistrict = dataTax.Thambol;
        // this.form.addressDistrict = dataTax.Amphur;
        // this.form.addressProvince = dataTax.Province;
        // this.form.addressZipcode = dataTax.PostCode;
      }
    },
    contractDocumentRemoveDialog(item) {
      this.isConfirmContractDocumentRemove = true;
      this.isContractDocumentId = item.objectId;
    },
    async contractDocumentRemove() {
      this.isLoadingContractDocument = true
      try {
        await this.$store.dispatch("contractDocument/removeContractDocument", {
          id: this.isContractDocumentId
        });
        await this.$store.dispatch("contractDocument/getContractDocuments", {
          areaInterestId: this.form.objectId
        });
        this.isLoadingContractDocument = false;
      } catch (err) {
        this.isLoadingContractDocument = false;
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        })
      }
    },
    contractDocumentDialog(e, isUpdate = false, isDisable = false) {
      this.isContractDocumentUpdate = isUpdate || false;
      this.isContractDocumentDisable = isDisable || false;
      if (isUpdate) {
        this.isContractDocumentId = e.objectId;
      }
      this.isContractDocument = true;
    },
    async onMarketChange() {
      this.isLoadingArea = true;
      try {
        this.form.areaIds = []
        let result = await Market.getMarketArea({
          id: this.form.marketId
        })
        this.areaOptions = result.areas.sort(function (a, b) {
          if (b.order > a.order) return -1;
          else return 1;
        });
        this.isLoadingArea = false
      } catch (err) {
        console.log(err)
        this.isLoadingArea = false
        this.$toast.show({
          content: this.$t('error'),
          color: "error"
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// .dialog-interest-form {
//   overflow: hidden;
//   min-height: 500px;
// }
.dialog-interest-form-in.v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}

.active-select {
  @apply border-screamin-green-600 text-screamin-green-600 bg-screamin-green-50;
}

.border-box {
  border: 1px solid rgba(223, 223, 223, 0.5);
  border-radius: 5px;
}

.note {
  color: gray;
  font-size: 12px;
}
</style>
